export interface InspectionTypeInfo {
  value: string
  label: string
}

export const INSPECTION_TYPES: InspectionTypeInfo[] = [
  { value: 'rug', label: 'RUG' },
  { value: 'raut', label: 'RAUT' },
  { value: 'phased-array', label: 'Phased Array' },
  { value: 'trilat', label: 'Trilat' },
  { value: 'lidar', label: 'Lidar' },
  { value: 'ie', label: 'IE' },
  { value: 'sasw', label: 'SASW' },
  { value: 'upe', label: 'UPE' },
  { value: 'manual', label: 'Manual' },
  { value: 'api', label: 'API' },
  { value: 'mfl', label: 'MFL' },
  { value: 'emat', label: 'EMAT' },
  { value: 'mi', label: 'MI' },
  { value: 'art', label: 'ART' },
  { value: 'pulsed-eddy-current', label: 'PEC' },
  { value: 'drone', label: 'Drone' },
  { value: 'frp', label: 'FRP' },
  { value: 'pt', label: 'Penetrant Testing' },
  { value: 'brick-tile-inspection', label: 'Brick and Tile Inspection' },
  { value: 'external-visual', label: 'External Visual' },
  { value: 'internal-visual', label: 'Internal Visual' },
  { value: 'profile-radiography', label: 'Profile Radiography' },
  { value: 'infrared-thermography', label: 'Infrared Thermography' },
  { value: 'spark-testing', label: 'Spark Testing' },
  { value: 'lift-lever-test', label: 'Lift Lever Test' },
  { value: 'photogrammetry', label: 'Photogrammetry' },
]

export const INSPECTION_TYPE_LABELS: Record<string, string> =
  INSPECTION_TYPES.reduce(
    (acc, type) => {
      acc[type.value] = type.label
      return acc
    },
    {} as Record<string, string>
  )
